<template>
  <grouped-participants
    v-if="numberOfParticipantsWhoSpentLess > 1"
    :number-of-participants="numberOfParticipantsWhoSpentLess"
    :stack-direction="StackDirection.DOWN"
    label-text="שהוציא פחות"
  />
  <participant-status
    v-for="participant in challengeStore.orderedParticipantsForDisplay"
    :key="participant.participantId"
    :participant="participant"
    class="participant"
    :class="{ me: participant.isMe, isBeforeMe: isBeforeMe(participant.participantId) }"
  />
  <grouped-participants
    v-if="numberOfParticipantsWhoSpentMore > 1"
    :number-of-participants="numberOfParticipantsWhoSpentMore"
    :stack-direction="StackDirection.UP"
    label-text="שהוציאו יותר"
  />
</template>

<script lang="ts" setup>
import * as _ from 'lodash';
import { storeToRefs } from 'pinia';
import ParticipantStatus from './ParticipantStatus.vue';
import { useChallengeStore } from '../../stores/challenge';
import { ParticipantId } from '../../types/participant';
import { StackDirection } from './consts';
import GroupedParticipants from './GroupedParticipants.vue';

const challengeStore = useChallengeStore();
const { numberOfParticipantsWhoSpentLess, numberOfParticipantsWhoSpentMore } = storeToRefs(challengeStore);

const isBeforeMe = (participantId: ParticipantId) => {
  const index = _.findIndex(challengeStore.orderedParticipantsForDisplay, p => p.participantId === participantId);
  if (index >= 0 && index < challengeStore.orderedParticipantsForDisplay.length - 1) {
    return challengeStore.orderedParticipantsForDisplay[index + 1]?.isMe;
  }
  return false;
};

</script>

<style lang="scss" scoped>
@import 'base-ui-vue3/src/scss/riseup-colors';
@import '@riseupil/base-ui/src/scss/spacings';

.participant {
  border-bottom: 1px solid $riseup_gray_0;

  &.isBeforeMe {
    border-bottom: none;
  }

  &.me {
    background-color: $riseup_gray_disabled;
    margin: 0 (-$ri-spacing-ml);
    padding: 0 $ri-spacing-ml;
    border-bottom: 0;
  }
}

</style>
